import type { ReactNode } from 'react';
import { Wordmark } from './Logo';
import { Link } from 'react-router-dom';

export function TopBar({ right, tone = 'ink', to = '/' }: { right?: ReactNode; tone?: 'ink' | 'paper'; to?: string }) {
  return (
    <header className="container flex items-center justify-between py-5">
      <Link to={to} aria-label="تيمبو"><Wordmark height={28} tone={tone} /></Link>
      <div className="flex items-center gap-3">{right}</div>
    </header>
  );
}

export function Notice({ kind = 'info', children }: { kind?: 'info' | 'ok' | 'warn' | 'danger'; children: ReactNode }) {
  const cls = { info: 'bg-paper-2 text-ink', ok: 'bg-ok-bg text-ok', warn: 'bg-warn-bg text-warn', danger: 'bg-danger-bg text-danger' }[kind];
  return <div role={kind === 'danger' ? 'alert' : 'status'} className={`rounded-[var(--radius-md)] px-4 py-3 font-medium ${cls}`}>{children}</div>;
}

export function Spinner({ label = 'لحظة' }: { label?: string }) {
  return (
    <div className="flex items-center gap-3 muted" aria-live="polite">
      <span className="inline-block size-4 rounded-full border-2 border-line border-t-ink animate-spin" /> {label}
    </div>
  );
}

export function Stat({ label, value, sub }: { label: string; value: ReactNode; sub?: ReactNode }) {
  return (
    <div className="card p-5">
      <div className="muted text-sm font-semibold">{label}</div>
      <div className="display num mt-1" style={{ fontSize: 'clamp(1.8rem,4vw,2.6rem)' }}>{value}</div>
      {sub && <div className="muted text-sm mt-1">{sub}</div>}
    </div>
  );
}

export function Footer() {
  return (
    <footer className="container py-10 muted text-sm border-t border-line mt-16">
      <div className="flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
        <div>تيمبو، مشغّل تقني لنظام العضويات في محلات الحلاقة الرجالية. البائع للزبون هو المحل، وأسعار باقاته يحددها المحل.</div>
        <div className="flex gap-4"><Link to="/shop">شاشة المحل</Link><Link to="/admin">الإدارة</Link></div>
      </div>
    </footer>
  );
}
